import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // width: "300px",
  },

  container_noMargin: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    // width: "300px",
  },

  label: {
    color: "#353535",
    fontSize: "18px",
    fontWeight: 500,
    letterSpacing: 0,
  },
}));

export default useStyles;
